export default __webpack_public_path__ + "static/media/csi_video_active.5bd5f20a.svg";